import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const teamApi = {
    getList(activityId) {
        return httpClient.get(API_ROUTES.team_list, {
            params: { teamId: activityId },
        })
    },

    getDetail(teamId) {
        return httpClient.get(API_ROUTES.team_get, {
            params: { id: teamId },
        })
    },

    getAvailableMembers(activityId) {
        return httpClient.get(API_ROUTES.team_memberList, {
            // 年份缺省时仍显式传空值，兼容后端按“全部队员”返回可选名单。
            params: { activityId: activityId || '' },
        })
    },

    create(payload) {
        return httpClient.post(API_ROUTES.team_create, payload)
    },

    addMember(formData) {
        return httpClient.post(API_ROUTES.team_set, formData)
    },

    removeMember(formData) {
        return httpClient.post(API_ROUTES.team_remove, formData)
    },

    delete(formData) {
        return httpClient.post(API_ROUTES.team_delete, formData)
    },

    getCharts(gameYearId) {
        return httpClient.get(API_ROUTES.team_charts, {
            params: { gameYearId },
        })
    },
}
